import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import checkRole from '../../helpers/checkRole';
import { logout } from '../../redux/actions/auth';
import { socket } from '../../socket';
import CreateRoom from '../CreateRoom/CreateRoom';
import { Icon } from '../Icon';
import TimerPR from '../TimerPR/TimerPR';
import start from '../../assets/sounds/start.mp3';
import waiting from '../../assets/sounds/waiting.mp3';
import { useCheckUserBlock } from '../../helpers/checkUserBlock';
import { useCheckSystemStatus } from '../../helpers/checkSystemStatus';


const HeaderAuth = (props) => {
    const { t } = useTranslation();
    const {user} = useSelector((state) => state.currentUser);
    const list = useSelector(state=>state.list)
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const { userConsent } = location.state || {};
    const [open, setOpen] = useState(false);
    const [openInner, setOpenInner] = useState(false);
    const [openRight, setOpenRight] = useState(false);
    const [openNotifications, setOpenNotifications] = useState(false);
    const [openNotifications2, setOpenNotifications2] = useState(false);
    const [newNotification, setNewNotification] = useState(false);
    const checkSystemStatus = useCheckSystemStatus();
    const [newNotificationArbitr, setNewNotificationArbitr] = useState(false);
    const [newNotificationAdmin, setNewNotificationAdmin] = useState(false);
    const [newNotificationVerification, setNewNotificationVerification] = useState(false);
    const [newNotificationSupport, setNewNotificationSupport] = useState(false);


    
    const [openDownloads, setOpenDownloads] = useState(false);
    const hint = useSelector((state) => state.hints);


    const [openNotificationsOuter, setOpenNotificationsOuter] = useState(false);
    const [notifications, setNotifications] = useState([]);
    const [openRoomsList, setOpenRoomsList] = useState(false);
    const [rooms, setRooms] = useState([]);
    const [isOpenCreate, setIsOpenCreate] = useState(false);
    const menuRef = useRef(null); // Ref for the left side menu
    const menuRefInner = useRef(null); 
    const menuRightRef = useRef(null); // Ref for the right side menu
    const menuNotificationRef = useRef(null); // Ref for the right side menu
    const menuNotificationRef2 = useRef(null); // Ref for the right side menu
    const menuDownloadRef = useRef(null); // Ref for the right side menu
    
    const menuNotificationRefOuter = useRef(null);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isSuperAdmin, setIsSuperAdmin] = useState(false);
    const checkUserBlock = useCheckUserBlock();

    const logOutClick = () => {
        dispatch(logout());
        navigate('/login');
    };

    const setTopicClick = (topic) => {
        props.setTopic(topic);
        localStorage.setItem('Theme', topic);
    };

    const openMenu = () => {
        setOpen(!open);
    };

    const openMenuRight = () => {
        setOpenRight(!openRight);
    };

    const openMenuInner = () => {
        setOpenInner(!openInner);
    }

    const openNotification = () => {
        if(!openNotifications){
            socket.emit('privateMessageGet',{});
            setNewNotification(false);
        }
        setOpenNotifications(!openNotifications);
    };
    const openDownload = () => {
        setOpenDownloads(!openDownloads);
    };

    const onCreateRoom = () => {
        if (!checkUserBlock(user)) return;
        const isActive = checkSystemStatus();
        if (!isActive) return;

        if (!userConsent) {
            navigate('/conditions', { state: { fallback: location.pathname } });
        } else {
            setIsOpenCreate(true);
        }
    }

    const onNotificationClick = (el) => {
        
        if (el.type === 2 || el.type === 1 || el.type === 5) {
            navigate('/room/'+el.roomId);
        }
        else if (el.type === 3) {
            navigate('/supportRoom/'+el.roomId);
        }
        else if (el.type === 4) {
            navigate('/profile/settings/'+el.userId);
        }
        socket.emit('privateMessageRead', {id: el.id});
        openNotification();
    }

    const getNotifications=(resp)=>{
        if(resp && resp[0] && resp[0]?.isRead=='0'){
            setNewNotification(true);
        }else{
            setNewNotification(false);
        }
        if(resp){
            setNotifications(resp);
        }
    }

    const getAdminNotifications =(resp)=>{
        if(resp.verification){
            
            setNewNotificationVerification(true);
        }else if(!resp.verification){
            setNewNotificationVerification(false);
        }
        if(resp.admin){
            setNewNotificationAdmin(true)
        }else if(!resp.admin){
            setNewNotificationAdmin(false);
        }
        if(resp.arbitr){
            setNewNotificationArbitr(true)
        }else if(!resp.arbitr){
            setNewNotificationArbitr(false);
        }
    }
    const getSupportMessage=(resp)=>{
        if(resp?.support?.length>0){
            setNewNotificationSupport(true);
        }else{
            setNewNotificationSupport(false);
        }
    }

    const wasCreated=(resp)=>{
        navigate('/room/'+resp)
    }

    const soundStart = new Audio(start);
    const soundWaiting = new Audio(waiting);
    const lastStatuses = useRef({}); // Зберігає останні статуси кімнат
    const playedStatuses = useRef(new Set(JSON.parse(localStorage.getItem('playedStatuses')) || []));
    
    const getMyRooms = (resp) => {
        const sortedRooms = resp && resp.sort((a, b) => {
            return (a.status === '20ba716e-3597-4751-84b3-8fdf453cd005') - (b.status === '20ba716e-3597-4751-84b3-8fdf453cd005');
        })
        setRooms(sortedRooms);
        resp.forEach(room => {
            const prevStatus = lastStatuses.current[room.id];
            const newStatus = room.status;

            if (prevStatus !== newStatus && !playedStatuses.current.has(newStatus)) {
                if (newStatus === "20ba716e-3597-4751-84b3-8fdf453cd002") {
                    playSound(soundWaiting);
                } else if (newStatus === "20ba716e-3597-4751-84b3-8fdf453cd003") {
                    playSound(soundStart);
                }
                playedStatuses.current.add(newStatus);
                localStorage.setItem('playedStatuses', JSON.stringify([...playedStatuses.current]));
            }
            lastStatuses.current[room.id] = newStatus; // Оновлюємо останній статус кімнати
        });
    };
    const playSound = (audio) => {
        setTimeout(() => {
            audio.play();
        }, 0);
        setTimeout(() => {
            audio.pause();
            audio.currentTime = 0; 
        }, 5000);
    };


    const setOpenRoomsListClick=()=>{
        setOpenRoomsList(!openRoomsList);
        socket.emit('getMyRooms',{});
    }

    socket.on('privateMessage',getNotifications);
    socket.on('adminPrivateMessage',getAdminNotifications);
    socket.on('supportMessage',getSupportMessage);
    socket.on('roomsMyList',getMyRooms);
    socket.on('wasCreated',wasCreated);
    useEffect(() => {
        if(user?.role){
            setIsAdmin(checkRole(user,'admin'));
            setIsSuperAdmin(checkRole(user, 'superAdmin'));
        }
    }, [user]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && 
                !menuRef.current.contains(event.target)) {
                setOpen(false);
            }
            if (menuRightRef.current && !menuRightRef.current.contains(event.target)) {
                setOpenRight(false);
            }
            if(menuNotificationRef.current && 
                !menuNotificationRef.current.contains(event.target)) {
                setOpenNotifications(false);
            }
            if(menuDownloadRef.current && 
                !menuDownloadRef.current.contains(event.target)) {
                setOpenDownloads(false);
            }
            
            if(menuNotificationRef2.current && 
                !menuNotificationRef2.current.contains(event.target)) {
                setOpenNotifications2(false);
            }
            
            if (menuRefInner.current && !menuRefInner.current.contains(event.target)) {
                setOpenInner(false);
            }
            if(menuNotificationRef.current && !menuNotificationRef.current.contains(event.target)) {
                setOpenNotifications(false);
            }
            if(menuNotificationRefOuter.current && !menuNotificationRefOuter.current.contains(event.target)) {
                setOpenNotificationsOuter(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };

    }, [menuRef, menuRefInner, menuRightRef, menuNotificationRef,menuDownloadRef, menuNotificationRefOuter]);

    useEffect(() => {
        const { openSidebar } = location.state || {};
        const { team } = location.state || {};

        if (openSidebar && !team) {
            setIsOpenCreate(true);

            navigate(location.pathname, { replace: true, state: {} });
        }
    }, [location.state])

    return (
        <>
        <div className='headerPosition' style={location.pathname === '/conditions' ? { visibility: 'hidden' } : {}}>
            <div className='headerAuth prFlexRow'>
                <div className='headerLogo'>
                    <div className='headerLogoLogo pointer' onClick={() => navigate('/')}>
                        <Icon type='logo'></Icon>
                    </div>

                    <div className="headerLogoText" onClick={() => navigate('/')}>
                        <Icon type="rivalsLogoText"/>
                    </div>

                    {/* <div className='headerTheme'>
                        <div onClick={() => setTopicClick('black')} className={props.topic === 'white' ? 'selected' : 'selected active'}>
                            <Icon type='darkTheme'></Icon>
                        </div>
                        <div onClick={() => setTopicClick('white')} className={props.topic === 'black' ? 'selected' : 'selected active'}>
                            <Icon type='lightTheme'></Icon>
                        </div>
                    </div> */}
                </div>
                <div className='prFlexRow' style={{ gap: '30px' }}>
                <div className='emptyDiv' style={user && checkRole(user, 'arbitr') ? { display:'none' } : {}}/>
                {user && checkRole(user,'arbitr')?
                <div>
                    
                </div>
                :rooms.length>0 && <div className='userAttempt prFlexRow'>
                        <div className='addUserAttempt' onClick={onCreateRoom}> <Icon type='plus'></Icon></div>
                        <div style={{cursor:'pointer'}} onClick={()=>navigate('/room/'+rooms[0].id)}>
                            <div className='prFlexRow'>
                                <Icon type='playController'></Icon>
                                <div className='userAttemptStatus'>
                                    {list[rooms[0].status]}
                                </div>
                            </div>
                            <div className='userAttemptTime'>
                                <TimerPR initialSeconds={rooms[0].termExistence} />
                            </div>
                        </div>
                        <div className='numberUserAttempt' onClick={setOpenRoomsListClick}>{rooms.length}</div>
                    
                        {openRoomsList &&
                        <div className='userAttemptList'>
                            {rooms.map((el,index)=>{
                                if(index === 0){
                                    return null;
                                }
                                return(
                                    <div className='userAttempt prFlexRow'>
                                        <div style={{cursor:'pointer'}} onClick={()=>navigate('/room/'+el.id)}>
                                            <div className='prFlexRow'>
                                                <Icon type='playController'></Icon>
                                                <div className='userAttemptStatus'>
                                                    {list[el.status]}
                                                </div>
                                            </div>
                                            <div className='userAttemptTime'>
                                                <TimerPR initialSeconds={el.termExistence} />
                                            </div>
                                        </div>
                                    </div>
                                )
                                })}
                        </div>
                         }
                    </div>}
                    

                    {user && checkRole(user,'arbitr')?
                    <div className='adminHeaderIcons'>
                        <div className={newNotificationAdmin ?'redDot':''}><Icon type='addminreq' onClick={()=>navigate('/addminreq')}></Icon></div>
                        <div className={newNotificationArbitr ?'redDot':''}><Icon type='arbitr' onClick={()=>navigate('/arbitr')}></Icon></div>
                        {/* Технічне завдання на модернізацію */}
                        {/* {user && checkRole(user,'admin') &&<div className={newNotificationVerification ?'redDot':''}><Icon type='verification' onClick={()=>navigate('/verificationlist')}></Icon></div>} */}
                        <div className={newNotificationSupport ?'redDot':''}><Icon type='support' onClick={()=>navigate('/supportList')}></Icon></div>
                    </div>
                    : <div className='prFlexRow headerMoney'>
                        <div className='headerMoneyWallet'><Icon onClick={()=>navigate('/profile/wallet')} type='wallet'></Icon></div>
                        <div>
                            <div className='prFlexRow'>
                                <Icon type='fTocken'></Icon>
                                <div>
                                    <span className='prTockenEvailable'>{user?.userMoney?.balanceFiat} </span>/<span className='prTockenBlocked'> {user?.userMoney?.balanceFiatFrozen}</span>
                                </div>
                            </div>
                            <div className='prFlexRow'>
                                <Icon type='cTocken'></Icon>
                                <div>
                                    <span className='prTockenEvailable'>{user?.userMoney?.balanceCoin} </span>/<span className='prTockenBlocked'> {user?.userMoney?.balanceCoinFrozen}</span>
                                </div>
                            </div>
                        </div>
                    </div>}

                    <div className='prFlexRow headerUser sideMenu' onClick={openMenu} ref={menuRef}>
                        <div className='headerUserAvatar'  style={{backgroundImage:`url(${user?.avatarImg})`}} >
                            {!user?.avatarImg && <Icon type='avatar'></Icon>}
                        </div>
                        <div>
                            <div className='nickname'>
                                {user?.nickname}
                            </div>
                            {user && checkRole(user,'arbitr')?
                            <div className='nickname' style={{fontSize:'12px'}}>
                                {user &&(checkRole(user,'superAdmin') && 'Супер Адмін') || (checkRole(user,'admin')&&'Admin:' ) ||  (checkRole(user,'arbitr') && 'Арбітр')}
                            </div>
                            :<div className='prFlexRow'>
                                <span className='reputation'>{t('reputation')}:</span> 
                                <div className={
                                        (user?.reputation > 6 && "reputationNumber") ||
                                        ((user?.reputation < 7 && user?.reputation > 3) && "reputationNumber caution") ||
                                        (user?.reputation < 4 && "reputationNumber error")
                                }>{user?.reputation} {(user?.reputation > 4 && t('points')) || (user?.reputation > 1 && t('pointss')) || (user?.reputation === 1 && t('point')) || (user?.reputation === 0 && t('points'))}
                            </div>
                            </div>}
                        </div>

                        {open && <div className='openSideMenu'>
                            <div className='openSideMenuNavigation'>
                               {!isAdmin && <div onClick={()=>navigate('/profile/myGames')}>{t('my_games')}</div>}
                                {!isAdmin && <div onClick={()=>navigate('/profile/rooms')}>{t('rooms')}</div>}
                                <div onClick={()=>navigate('/profile/wallet')}>{t('wallet')}</div>
                                {user.isStatus==0 && !isAdmin &&<div onClick={()=>navigate('/verification')}>{t('accaunt_verifcation')}</div>}
                                <div onClick={()=>navigate('/profile/settings')}>{t('settings')}</div>
                            </div>
                            <div className='openSideMenuExit' onClick={logOutClick}>
                                <Icon type='exit' />  {t('log_out')}
                            </div>
                        </div>}
                    </div>

                    <div className='headerButtons prFlexRow'>
                       {user && !checkRole(user,'arbitr') &&<div className={newNotificationSupport ?'redDot':''}>
                            <Icon type='support' onClick={()=>navigate('/supportList')}></Icon>
                        </div>}
                        <div className={newNotification ?'redDot':''}>
                            <Icon type='notification' onClick={openNotification}></Icon>
                        </div>
                        <div >
                            <Icon type='download' onClick={openDownload}></Icon>
                        </div>
                        <div >
                                <Icon type='more' onClick={openMenuRight}></Icon>
                            </div>
                        <div className='sideMenu' ref={openDownloads?menuDownloadRef:openNotifications?menuNotificationRef:menuRightRef}>
                            {openDownloads && <div className='openSideMenu openSideMenuBig downloadCli openSideMenuRight'>
                                <div className='openSideMenuNotifications'>
                                    <h3 dangerouslySetInnerHTML={{__html: hint[74].description}}></h3>
                                </div>
                            </div>}
                            {openNotifications && <div className='openSideMenu openSideMenuBig openSideMenuRight'>
                                <div className='openSideMenuNotifications'>
                                    <h3>Повідомлення</h3>
                                    <div className='openSideMenuNotificationsBody'>
                                    {notifications.map(el=>{
                                        return(
                                        <div className='notificationItem' onClick={(e) => onNotificationClick(el)}>
                                            <div className='dFlex'>
                                                <div className={el.isRead===1?'read':'read unread'}>
                                                </div>
                                                <div>
                                                    <div className='notificationItemHeader'>
                                                        {el.type===0 && 'Запит адміністратора: '}
                                                        {el.type===1 && 'Запит арбітра: '}
                                                        {el.type===2 && `Вас запрошено в гру ${el.description}: `}
                                                        {el.type===3 && `Нове повідомлення в підтримці `}
                                                        {el.type===4 && `Нове звернення на верифікацію `}
                                                        {el.type===5 && `Кімната закрита`}
                                                        <span>{el.nickname}</span>
                                                    </div>
                                                   {el.type!==2 && <div className='notificationItemText'>
                                                        {el.description}
                                                    </div>}
                                                    <div className='dFlex notificationItemTime'>
                                                        <Icon type='time'></Icon>  {el.time}
                                                    </div>
                                                </div>
                                                
                                            </div>
                                            
                                        </div>
                                        )
                                        
                                    })}
                                     </div>
                                </div>
                        </div>}
                        {openRight && <div className='openSideMenu openSideMenuBig openSideMenuRight'>
                                <div className='openSideMenuNavigation'>
                                    {isAdmin && <div  onClick={() => {navigate('/users');openMenuRight();}}>{t('users_all')}</div>}
                                    {/* <div>{t('Dictionary')}</div> */}
                                    {isAdmin && <div onClick={() => {navigate('/directory');openMenuRight();}}>{t('directory')}</div>}
                                    {isAdmin &&<div onClick={() => {navigate('/games');openMenuRight();}}>{t('games')}</div>}
                                    <div onClick={() => {navigate('/gamesLibrary');openMenuRight();}}>{t('games_library')}</div>
                                    {isAdmin && <div onClick={() => {navigate('/allRooms');openMenuRight();}}>{t('Всі кімнати')}</div>}
                                    {isAdmin &&<div onClick={() => {navigate('/transactionList');openMenuRight();}}>{t('Всі транзакції')}</div>}
                                    {isAdmin &&<div onClick={() => {navigate('/blacklist');openMenuRight();}}>{t('Чорний список')}</div>}
                                    {isSuperAdmin &&<div onClick={() => {navigate('/hints');openMenuRight();}}>{t('Текстові константи')}</div>}
                                    {isAdmin &&<div onClick={() => {navigate('/logs');openMenuRight();}}>{t('Журнал дій')}</div>}
                                    {isSuperAdmin &&<div onClick={() => {navigate('/settings');openMenuRight();}}>{t('Налаштування системи')}</div>}
                                </div>
                                <div className='sideMenuMobile'>
                                    <div
                                        className='prFlexRow headerUser sideMenu'
                                        onClick={openMenuInner}
                                        ref={menuRefInner}
                                    >
                                        <div className='prFlexRow' style={{ gap: '10px' }}>
                                            <div className='headerUserAvatar' style={{backgroundImage:`url(${user?.avatarImg})`}}>
                                            {!user?.avatarImg && <Icon type='avatar'></Icon>}
                                            </div>
                                            <div>
                                                <div className='nickname'>
                                                    {user?.nickname}
                                                </div>
                                                {user && checkRole(user,'arbitr')?
                                                <div className='nickname' style={{fontSize:'12px'}}>
                                                    {user &&(checkRole(user,'superAdmin') && 'Супер Адмін') || (checkRole(user,'admin')&&'Admin:' ) ||  (checkRole(user,'arbitr') && 'Арбітр')}
                                                </div>
                                                :<div className='prFlexRow'>
                                                    <span className='reputation'>{t('reputation')}:</span> 
                                                    <div className={
                                                            (user?.reputation > 6 && "reputationNumber") ||
                                                            ((user?.reputation < 7 && user?.reputation > 3) && "reputationNumber caution") ||
                                                            (user?.reputation < 4 && "reputationNumber error")
                                                    }>{user?.reputation} {(user?.reputation > 4 && t('points')) || (user?.reputation > 1 && t('pointss')) || (user?.reputation === 1 && t('point')) || (user?.reputation === 0 && t('points'))}
                                                </div>
                                                </div>}
                                            </div>
                                        </div>

                                        {openInner && 
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    width: '100%'
                                                }}
                                            >
                                                <div className='openSideMenuNavigation'>
                                                    <div onClick={()=>navigate('/profile/myGames')}>{t('my_games')}</div>
                                                    <div onClick={()=>navigate('/profile/rooms')}>{t('rooms')}</div>
                                                    <div onClick={()=>navigate('/profile/wallet')}>{t('wallet')}</div>
                                                    {user && checkRole(user,'admin') && <div onClick={()=>navigate('/profile/varification')}>{t('accaunt_verifcation')}</div>}
                                                    <div onClick={()=>navigate('/profile/settings')}>{t('settings')}</div>
                                                </div>
                                                <div className='openSideMenuExit' onClick={logOutClick}>
                                                    <Icon type='exit' />  {t('log_out')}
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    <div className='prFlexRow headerMoney'>
                                        <div className='headerMoneyWallet' ><Icon type='wallet' onClick={()=>navigate('/profile/wallet')}></Icon></div>
                                        <div>
                                            <div className='prFlexRow'>
                                                <Icon type='fTocken'></Icon>
                                                <div>
                                                    <span className='prTockenEvailable'>{user?.userMoney?.balanceFiat} </span>/<span className='prTockenBlocked'> {user?.userMoney?.balanceFiatFrozen}</span>
                                                </div>
                                            </div>
                                            <div className='prFlexRow'>
                                                <Icon type='cTocken'></Icon>
                                                <div>
                                                    <span className='prTockenEvailable'>{user?.userMoney?.balanceCoin} </span>/<span className='prTockenBlocked'> {user?.userMoney?.balanceCoinFrozen}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className='prFlexRow'
                                        style={{
                                            paddingRight: '50px',
                                        }}
                                    >
                                        {/* <div className='headerTheme'>
                                            <div onClick={() => setTopicClick('black')} className={props.topic === 'white' ? 'selected' : 'selected active'}>
                                                <Icon type='darkTheme'></Icon>
                                            </div>
                                            <div onClick={() => setTopicClick('white')} className={props.topic === 'black' ? 'selected' : 'selected active'}>
                                                <Icon type='lightTheme'></Icon>
                                            </div>
                                        </div> */}
                                        <div className='prFlexRow' style={{ gap: '20px' }}>
                                            {user && !checkRole(user,'arbitr') && 
                                                <div className={newNotificationSupport ?'redDot':''}>
                                                    <Icon type='support'  onClick={()=> {
                                                        navigate('/supportList');
                                                        openMenuRight();
                                                    }}></Icon>
                                                </div>
                                            }
                                            <div className={newNotification ?'redDot':''}>
                                                <Icon type='notification' onClick={openNotification}></Icon>
                                            </div>
                                        </div>
                                    </div>
                                    {openNotifications && <div className='openSideMenuNotifications'>
                                        <h3>Повідомлення</h3>
                                        <div className='openSideMenuNotificationsBody'>
                                            {notifications.map(el=>{
                                                return(
                                                <div className='notificationItem' onClick={() => onNotificationClick(el)}>
                                                    <div className='dFlex'>
                                                        <div className={el.isRead===1?'read':'read unread'}>
                                                        </div>
                                                        <div>
                                                            <div className='notificationItemHeader'>
                                                                {el.type===0 && 'Запит адміністратора: '}
                                                                {el.type===1 && 'Запит арбітра: '}
                                                                {el.type===2 && `Вас запрошено в гру ${el.description}: `}
                                                                {el.type===3 && `Нове повідомлення в підтримці `}
                                                                {el.type===4 && `Нове звернення на верифікацію `}
                                                                <span>{el.nickname}</span>
                                                            </div>
                                                            {el.type!==2 && <div className='notificationItemText'>
                                                                {el.description}
                                                            </div>}
                                                            <div className='dFlex notificationItemTime'>
                                                                <Icon type='time'></Icon>  {el.time}
                                                            </div>
                                                        </div>
                                                    </div>   
                                                </div>
                                                )  
                                            })}
                                        </div>
                                    </div>}
                                </div>
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
        </div>

            {isOpenCreate && <CreateRoom isOpen={isOpenCreate} setIsOpen={setIsOpenCreate} ></CreateRoom>}
        </>
    );
};

export default HeaderAuth;
